import Rate from './Rate';
export default Rate;



// WEBPACK FOOTER //
// ./ext/rate/src/index.js